import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment as env } from '@environments/environment';
import { EntityApiBaseService } from './entity-api-base.service';
import { IGetCategoryParams, IZonePostModel } from '@src/app/models/zone.model';

@Injectable({
  providedIn: 'root',
})
export class CoreZoneApiService {
  private CATEGORY_RESOURCE = 'categories';
  private ZONES_RESOURCE = 'zones';

  constructor(
    private entityApiBaseService: EntityApiBaseService,
    private http: HttpClient,
  ) {}

  getCategories(params?: IGetCategoryParams) {
    const url = `${env.coreEntityApiBase.url}/${this.CATEGORY_RESOURCE}`;
    return this.entityApiBaseService.getAll(url, params);
  }

  deleteZone(zoneId: string) {
    const url = `${env.coreEntityApiBase.url}/${this.ZONES_RESOURCE}/${zoneId}`;
    return this.entityApiBaseService.deleteWithPatch(url);
  }

  createZone(params?: IZonePostModel) {
    const url = `${env.coreEntityApiBase.url}/${this.ZONES_RESOURCE}`;
    return this.http.post(url, params, {observe: 'response'})
  }
}
